import { Component , OnInit } from '@angular/core';
import { CognitoUtil } from '../../../../main/shared/services/cognito.service';
import {  Router } from '@angular/router';
@Component({
    selector : 'logout',
    template : ' ',
   
})

export class logoutComponent implements OnInit {
  constructor(private router: Router, private cognito: CognitoUtil) {}
  ngOnInit() {
      this.logout() ; 
  }
  logout() {
    // localStorage.removeItem('userDetails');
    this.cognito.logout();
    localStorage.clear();
    this.router.navigate(['login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/logout/logout.component.ts